import { CopyButton } from "../Button";
import { CopyButtonProps } from "../Button/CopyButton";
import { Box, BoxProps } from "./Box";

interface Props extends BoxProps {
  value: string;
  copyButtonProps?: Partial<CopyButtonProps>;
  hideCopyButton?: boolean;
}

export const CopyableBox = ({
  children,
  value,
  copyButtonProps,
  hideCopyButton,
  ...props
}: Props) => {
  return (
    <Box
      display="flex"
      sx={{
        gap: "4px",
        alignItems: "center",
        "#copy-button": {
          visibility: "hidden",
        },
        "&:hover": {
          "#copy-button": {
            visibility: "visible",
          },
        },
      }}
      {...props}
    >
      {children}
      {!hideCopyButton && <CopyButton value={value} {...copyButtonProps} />}
    </Box>
  );
};
